
<template>
    <div class="main">
        <!-- <div>
            <input type="text" v-model="text"><button @click="makeCode(text)">生成二维码</button>
        </div> -->
        <div style="width: 120px;height: 120px">
            <div id="qrcode"></div> <!-- 创建一个div，并设置id为qrcode -->
        </div>
    </div>
</template>

<script>
    import QRCode from 'qrcodejs2'  // 引入qrcode
    export default {
        name : 'Qcode',
        data () {
            return {
                // text: 'http://www.baidu.com',
                codeObj: null
            }
        },
        props:{
            text:{
                type: String,
                default: '',
            }
        },
        mounted () {
            this.qrcode();                   
        },
        methods: {            
            qrcode() {
                this.codeObj = new QRCode('qrcode', {
                    text: this.text,
                    width: 120,
                    height: 120,
                    colorDark : "#000",
                    colorLight : "#fff",
                })
            },
            makeCode (text) {
                this.codeObj.makeCode(text)
            }
        }
    }
</script>

<style scoped>
 .main{
     display: flex;
     flex-direction: column;
 }
</style>



// WEBPACK FOOTER //
// src/components/Qrcode/index.vue